'use client';

import type { ReactNode } from 'react';

/**
 * Matches the observability providers' capture-suppressed selector, so
 * PostHog autocapture, session replay and Datadog click events all skip
 * everything inside. The second class only keeps the wrapper out of layout.
 */
export const PRIVATE_FIELDS_CLASS = 'ph-no-capture signup-step__private';

const PRIVATE_FIELDS_STYLE_ID = 'signup-private-fields-style';

function ensurePrivateFieldsStyle(): void {
  if (typeof document === 'undefined' || document.getElementById(PRIVATE_FIELDS_STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = PRIVATE_FIELDS_STYLE_ID;
  style.textContent = '.signup-step__private { display: contents; }';
  document.head.appendChild(style);
}

/**
 * Wraps a step's member-entered health, contact and care details (address,
 * birth date, sex at birth, phone, email, booking choices, interpreter
 * language). The one private wrapper for every signup step: buttons and
 * explanatory copy stay outside it so their own interactions are still
 * measured.
 */
export function PrivateFields({ children }: { children: ReactNode }) {
  ensurePrivateFieldsStyle();
  return <div className={PRIVATE_FIELDS_CLASS}>{children}</div>;
}
